import latest from './4-0-0/index.md';

export default latest;
